<template>
  <el-dialog :visible.sync="dialogVisible" width="75%">
    <video
      id="player2"
      class="video-js vjs-big-play-centered"
      controls
      preload="auto"
      poster="http://easydss.socoton.com/fvod/jiaocheng/S4lApP3MR/video.m3u8"
      data-setup='{"videoWidth":1500px,"videoHeight":500px}'
    >
      <source
        type="application/x-mpegURL"
        src="http://easydss.socoton.com/fvod/jiaocheng/S4lApP3MR/video.m3u8"
      />
    </video>
    <div>
      <!-- {{socotonData}} -->
    </div>
  </el-dialog>
</template>

<script>
import "video.js/dist/video-js.css";
import "videojs-contrib-hls";
export default {
  props: ["socotonData"],
  data() {
    return {
      dialogVisible: false,
      player2: null,
      article: null,
    };
  },
  mounted(){},
  
  methods: {
    initVideo() {
      //此处初始化的调用，我放在了获取数据之后的方法内，而不是放在钩子函数mounted
      //页面dom元素渲染完毕，执行回调里面的方法
      this.$nextTick(() => {
        this.player2 = this.$video(document.getElementById("player2"), {
          //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
          controls: true,
          //自动播放属性,muted:静音播放
          autoplay: false,
          //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
          preload: "auto",
          //设置视频播放器的显示宽度（以像素为单位）
          width: "1500",
          //设置视频播放器的显示高度（以像素为单位）
          height: "600",
          controlBar: {
            playToggle: true,
          },
        });
      });
    },
    closeDialog(){
    }
  },
  mounted() {
    // this.initVideo();
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__header {
  border-bottom: none;
}
/deep/ .el-dialog {
  // background: red;
  height: 200px !important;
}
/deep/ .el-dialog__body{
  height: 200px;
}
iframe {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/view/Panel/caozuoshouce/dialog.vue